// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/intelligence/v1/intelligence.proto (package mono.intelligence.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { BulkReviewFieldProposalsRequest, BulkReviewFieldProposalsResponse, CancelIntelligenceRunRequest, CancelIntelligenceRunResponse, CreateIntelligenceRunRequest, CreateIntelligenceRunResponse, GetIntelligenceRunRequest, GetIntelligenceRunResponse, GetWorkflowContractRequest, GetWorkflowContractResponse, ListIntelligenceRunsRequest, ListIntelligenceRunsResponse, MarkRunAppliedToDraftRequest, MarkRunAppliedToDraftResponse, RetryIntelligenceRunRequest, RetryIntelligenceRunResponse, ReviewFieldProposalRequest, ReviewFieldProposalResponse, StartIntelligenceRunRequest, StartIntelligenceRunResponse } from "./intelligence_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * IntelligenceService is the browser-facing IDP orchestration contract. It is
 * implemented by baltigo and reached through sabaody; it does not represent a
 * new deployable service. Phase 0 defines the contract only. Persistence and
 * handlers land with the shared foundation in Phase 1.
 *
 * @generated from service mono.intelligence.v1.IntelligenceService
 */ export const IntelligenceService = {
    typeName: "mono.intelligence.v1.IntelligenceService",
    methods: {
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.CreateIntelligenceRun
     */ createIntelligenceRun: {
            name: "CreateIntelligenceRun",
            I: CreateIntelligenceRunRequest,
            O: CreateIntelligenceRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.GetIntelligenceRun
     */ getIntelligenceRun: {
            name: "GetIntelligenceRun",
            I: GetIntelligenceRunRequest,
            O: GetIntelligenceRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.ListIntelligenceRuns
     */ listIntelligenceRuns: {
            name: "ListIntelligenceRuns",
            I: ListIntelligenceRunsRequest,
            O: ListIntelligenceRunsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.StartIntelligenceRun
     */ startIntelligenceRun: {
            name: "StartIntelligenceRun",
            I: StartIntelligenceRunRequest,
            O: StartIntelligenceRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.RetryIntelligenceRun
     */ retryIntelligenceRun: {
            name: "RetryIntelligenceRun",
            I: RetryIntelligenceRunRequest,
            O: RetryIntelligenceRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.CancelIntelligenceRun
     */ cancelIntelligenceRun: {
            name: "CancelIntelligenceRun",
            I: CancelIntelligenceRunRequest,
            O: CancelIntelligenceRunResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.ReviewFieldProposal
     */ reviewFieldProposal: {
            name: "ReviewFieldProposal",
            I: ReviewFieldProposalRequest,
            O: ReviewFieldProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.BulkReviewFieldProposals
     */ bulkReviewFieldProposals: {
            name: "BulkReviewFieldProposals",
            I: BulkReviewFieldProposalsRequest,
            O: BulkReviewFieldProposalsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.MarkRunAppliedToDraft
     */ markRunAppliedToDraft: {
            name: "MarkRunAppliedToDraft",
            I: MarkRunAppliedToDraftRequest,
            O: MarkRunAppliedToDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.intelligence.v1.IntelligenceService.GetWorkflowContract
     */ getWorkflowContract: {
            name: "GetWorkflowContract",
            I: GetWorkflowContractRequest,
            O: GetWorkflowContractResponse,
            kind: MethodKind.Unary
        }
    }
};
